"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=function(a,b){this.activeTargets=[],this.skippedTargets=[],this.observationTargets=[],this.observer=a,this.callback=b};exports.ResizeObserverDetail=a
//# sourceMappingURL=ResizeObserverDetail.js.map
